export default "__VITE_ASSET__Dk6uQ$UB__"